import { defineStore } from 'pinia'

export const useBreadcrumbStore = defineStore('breadcrumb', {
  state: () => ({
    title: 'menu.home',
    module: '',
    moduleLink: null,
    page: ''
  }),
  actions: {
    updateBreadcrumb(title: string, module: string, page: string, moduleLink: any = null) {
      this.title = title
      this.module = module
      this.page = page
      this.moduleLink = moduleLink
    }
  }
})